import { createEntityPickerField } from "./createEntityPickerField";
import type { TypedEntityPickerProps } from "./EntityPickerField";
import type { SourceId } from "../../api/types";

export type SourcePickerFieldProps = TypedEntityPickerProps<SourceId>;

export const SourcePickerField = createEntityPickerField<SourceId>("source");
